// extracted by mini-css-extract-plugin
export default {"loading":"Notes_loading__hciNY","notesMainBody":"Notes_notesMainBody__HPbrs","dayStart":"Notes_dayStart__xEM9Z","dayEnd":"Notes_dayEnd__s8N7a","ecalendar":"Notes_ecalendar__rCPs9"};